// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"d1455558","574":"fcf05cbe","884":"32866214"}[chunkId] + ".chunk.js";
};